import React from 'react';

interface Props {
  /**
   * Value of the `data-tour` attribute. The tour spotlights this element by
   * selector — placement: 'bottom' on the corresponding step puts the card
   * underneath the spotlit upper-half region.
   */
  name: string;
}

/**
 * Invisible upper-half sentinel for tour spotlights. Pinned to the top of
 * its closest positioned ancestor, covering ~55% of its height so the
 * spotlight cutout encompasses the visible top portion (header + first ~12
 * rows) instead of the entire scrollable region. The element itself is
 * inert and visually transparent:
 *
 *   - `pointer-events-none` — never intercepts user clicks
 *   - `aria-hidden="true"` — invisible to assistive tech
 *   - `-z-10` — sits behind real content
 *
 * Place the parent with `position: relative` so this absolute child anchors
 * correctly. Height (55%) is calibrated so the bottom edge lands near a row
 * divider on typical desktop viewports while leaving room for the popover.
 */
export const TourSentinel: React.FC<Props> = ({ name }) => (
  <div
    data-tour={name}
    aria-hidden="true"
    className="pointer-events-none absolute inset-x-2 top-2 h-[55%] -z-10"
  />
);
